import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { WellDetailsModel } from '../_models/well-details-model';
import { TimeSpan } from '../_models/time-span';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
  selector: 'app-base-date-range-selector',
  templateUrl: './base-date-range-selector.component.html',
  styleUrls: ['./base-date-range-selector.component.css']
})
export class BaseDateRangeSelectorComponent implements OnInit {

  dateBoundsSelectionForm: FormGroup;

  private _wellRecord: WellDetailsModel | any = 'no_record';

  private _mode = "multi";

  private _beginDateChangeSubscription: Subscription = null;

  @Input()
  public set wellRecord(newWellRecord: WellDetailsModel) {
    this._wellRecord = newWellRecord;

    if(this.dateBoundsSelectionForm != null) {
      this.dateBoundsSelectionForm.get("WellRecord").setValue(this._wellRecord);
    }
  };

  public get wellRecord(): WellDetailsModel {
    return this._wellRecord;
  }

  @Input()
  public set mode(newMode: string) {
    if(newMode == 'multi' || newMode == 'single') {
      this._mode = newMode;

      this.updateEndDateForMode();
    }
  }

  public get mode() {
    return this._mode;
  }

  beginDate: Date;
  endDate: Date;

  constructor(
    protected formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    //Every implementation needs to produce a begin date and end date, and accept a well record.
    this.dateBoundsSelectionForm = this.formBuilder.group({
      'BeginDate': [this.beginDate, []],
      'EndDate': [this.endDate, []],
      'WellRecord': [this.wellRecord, []]
    }, {
      validator: this.getTimespanOverlapValidator()
    });

    this._beginDateChangeSubscription = this.dateBoundsSelectionForm.controls['BeginDate'].valueChanges.subscribe((newValue) => {
      this.updateEndDateForBeginDateChange();
    });
  }

  ngOnDestroy():void {
    if(this._beginDateChangeSubscription == null) {
      this._beginDateChangeSubscription.unsubscribe();
    }
    this._beginDateChangeSubscription = null;
  }

  //Generates the validator for the time span forms
  getTimespanOverlapValidator() {
    return (group: FormGroup): { [key: string]: any } => {
      var ret: any = {};

      var wr: WellDetailsModel| any = group.get("WellRecord").value;
      var beginDate = group.get("BeginDate").value;
      var endDate = group.get("EndDate").value;

      if (wr == null || beginDate == null || endDate == null) {
        ret.loading = true;
      }
      else {

        var beginDateMidnight = new Date(beginDate.getFullYear(), beginDate.getMonth(), beginDate.getDate(), 0, 0, 0, 0);
        var endDateMidnight = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59, 999);

        beginDate = beginDateMidnight;
        endDate = endDateMidnight;

        if (beginDate.getTime() > endDate.getTime()) {
          ret.timespanReversed = true;
        }
        else if (wr !== 'no_record'){
          var proposedTS = new TimeSpan(beginDate, endDate);

          if (wr.Injections != null) {
            var injInts = wr.Injections.find((inj) => {

              var injTS = new TimeSpan(inj.InjectionDate, inj.EndDate);

              var intersect = proposedTS.Intersect(injTS);

              return intersect;
            });

            if (injInts != null) {
              ret.timespanOverlap = true;
            }
          }
        }
      }

      return ret;
    }
  }

  updateEndDateForBeginDateChange() {
    if(this._mode == 'single') {
      this.updateEndDateForMode();
    }
  }

  updateEndDateForMode() {
    if(this.dateBoundsSelectionForm != null) {

      var beginDate = this.dateBoundsSelectionForm.controls["BeginDate"].value;

      if(beginDate != null) {
        if(this._mode == 'single') {

          var newED = new Date(beginDate);

          newED.setHours(23);
          newED.setMinutes(59);
          newED.setSeconds(59);

          this.endDate = newED;

      
        }
        else if(this._mode == 'multi') {
          var newED = new Date(beginDate);

          var month = beginDate.getMonth();

          var taDate = new Date(beginDate.getFullYear(), month + 1, 0);

          var day = taDate.getDate();

          newED.setDate(day);
      
          newED.setHours(23);
          newED.setMinutes(59);
          newED.setSeconds(59);

          this.endDate = newED;
        }
      }

    
      this.dateBoundsSelectionForm.controls['EndDate'].setValue(this.endDate);
    }
  }
}
